export function Disclaimer() {
  return (
    <div className="legal-page">
      <div className="container">
        <h1>Risk Disclaimer</h1>
        <p className="legal-updated">Last updated: February 23, 2026</p>

        <div className="legal-content">
          <h2>1. General Risk Warning</h2>
          <p>
            <strong>
              Cryptocurrency and blockchain transactions carry significant risks, including the
              potential for total and irreversible loss of funds.
            </strong>{' '}
            By using CryptoGuardians, you acknowledge that you understand these risks and accept
            full responsibility for your own transaction decisions.
          </p>

          <h2>2. Informational Analysis Only</h2>
          <p>
            <strong>
              CryptoGuardians provides automated, informational risk analysis only.
            </strong>{' '}
            All risk scores, threat assessments, warnings, alerts, and analysis outputs are generated
            by automated software algorithms. They are provided for informational purposes only and
            do not constitute financial advice, investment advice, legal advice, tax advice, or any
            other form of professional advice.
          </p>

          <h2>3. No Financial or Investment Advice</h2>
          <p>
            <strong>
              Nothing provided by CryptoGuardians should be construed as financial or investment
              advice.
            </strong>{' '}
            CryptoGuardians does not recommend, endorse, or advise for or against any specific
            transaction, token, smart contract, protocol, or digital asset. You should consult with
            qualified financial, legal, and tax professionals before making any investment or
            transaction decisions.
          </p>
          <p>
            CryptoGuardians is not a registered investment advisor, broker-dealer, financial
            planner, or financial institution. No communication from CryptoGuardians&mdash;whether
            through the platform interface, risk scores, alerts, support channels, documentation,
            or any other medium&mdash;constitutes a recommendation or solicitation to buy, sell,
            hold, or transact in any digital asset or financial instrument.
          </p>

          <h2>4. No Guarantee of Accuracy or Detection</h2>
          <p>
            <strong>
              CryptoGuardians does not guarantee the accuracy, completeness, or reliability of any
              analysis, risk score, or threat assessment.
            </strong>{' '}
            The blockchain ecosystem evolves rapidly. New attack vectors, zero-day exploits, novel
            scam patterns, and previously unknown vulnerabilities emerge constantly. No automated
            security tool can detect all threats or prevent all losses. Risk scores and assessments
            represent the platform&rsquo;s best automated analysis at a specific point in time and
            may be incomplete, delayed, or inaccurate.
          </p>
          <p>
            A &ldquo;safe&rdquo; or &ldquo;low risk&rdquo; score does not mean a transaction is
            safe. A &ldquo;high risk&rdquo; score does not necessarily mean a transaction is
            malicious. All assessments are probabilistic estimates, not definitive determinations.
          </p>
          <p>
            <strong>
              CryptoGuardians makes no guarantee, warranty, or promise&mdash;express or
              implied&mdash;that its analysis will detect any or all threats, prevent any losses, or
              protect your digital assets in any way.
            </strong>{' '}
            The absence of a warning does not indicate safety. The presence of a warning does not
            indicate certainty of malice. You must exercise your own independent judgment at all
            times.
          </p>

          <h2>5. User Assumes All Risk</h2>
          <p>
            <strong>
              You assume all risk associated with your use of CryptoGuardians and your blockchain
              transactions.
            </strong>{' '}
            By using this service, you acknowledge and agree that:
          </p>
          <ul>
            <li>
              You are solely responsible for evaluating the risks of any transaction you initiate,
              approve, or execute
            </li>
            <li>
              CryptoGuardians is a supplementary tool and is not a substitute for your own
              independent research and due diligence
            </li>
            <li>
              You will not rely solely on CryptoGuardians analysis when making transaction decisions
            </li>
            <li>
              You understand that blockchain transactions are generally irreversible once confirmed
              on-chain
            </li>
            <li>
              You understand the inherent risks of cryptocurrency, decentralized finance (DeFi),
              and smart contract interactions
            </li>
            <li>
              Neither CryptoGuardians nor HAJ Solutions, Inc. is responsible for any losses you may
              incur
            </li>
          </ul>
          <p>
            <strong>
              You expressly agree that your use of CryptoGuardians is at your sole risk.
            </strong>{' '}
            You are solely and entirely responsible for any and all consequences of your blockchain
            transactions, whether or not CryptoGuardians analysis was consulted, available, or
            accurate at the time of your decision. No claim may be brought against CryptoGuardians
            or HAJ Solutions, Inc. for losses arising from transactions you approved, executed, or
            failed to execute.
          </p>

          <h2>6. Non-Custodial Service</h2>
          <p>
            CryptoGuardians is a non-custodial service. We do not:
          </p>
          <ul>
            <li>Hold, custody, or control any digital assets or private keys</li>
            <li>Execute, approve, submit, or sign transactions on your behalf</li>
            <li>Have the ability to freeze, reverse, or recover any blockchain transaction</li>
            <li>Access your wallet balance or holdings</li>
          </ul>
          <p>
            <strong>
              If you lose funds due to a malicious transaction, CryptoGuardians cannot recover them.
            </strong>{' '}
            Blockchain transactions are irreversible by design.
          </p>

          <h2>7. No Fiduciary Duty</h2>
          <p>
            <strong>
              Your use of CryptoGuardians does not create any fiduciary relationship, advisory
              relationship, or duty of care between you and HAJ Solutions, Inc.
            </strong>{' '}
            We are not your financial advisor, investment advisor, broker, dealer, or fiduciary in
            any capacity.
          </p>

          <h2>8. Blockchain-Specific Risks</h2>
          <p>
            You acknowledge that cryptocurrency and blockchain transactions involve inherent risks,
            including but not limited to:
          </p>
          <ul>
            <li>
              <strong>Irreversibility:</strong> Blockchain transactions cannot be reversed, canceled,
              or refunded once confirmed
            </li>
            <li>
              <strong>Smart contract risk:</strong> Smart contracts may contain vulnerabilities,
              bugs, or backdoors that can result in total loss of funds
            </li>
            <li>
              <strong>Market volatility:</strong> Cryptocurrency values can fluctuate dramatically
              and may lose all value
            </li>
            <li>
              <strong>Regulatory risk:</strong> Laws and regulations governing digital assets may
              change, potentially affecting the legality or value of your holdings
            </li>
            <li>
              <strong>Protocol risk:</strong> Network congestion, forks, protocol changes, or chain
              reorganizations may affect transaction execution
            </li>
            <li>
              <strong>Social engineering:</strong> Phishing attacks, impersonation, and social
              engineering are prevalent in the cryptocurrency ecosystem
            </li>
            <li>
              <strong>Approval exploits:</strong> Token approvals granted to malicious smart
              contracts can result in complete drainage of approved tokens
            </li>
          </ul>

          <h2>9. Limitation of Liability</h2>
          <p>
            <strong>
              To the maximum extent permitted by applicable law, HAJ Solutions, Inc. shall not be
              liable for any losses, damages, or claims arising from or related to:
            </strong>
          </p>
          <ul>
            <li>
              Your reliance on any risk score, threat assessment, or analysis provided by
              CryptoGuardians
            </li>
            <li>
              Any transaction you approve, reject, or execute based on information from
              CryptoGuardians
            </li>
            <li>Any undetected threats, scams, exploits, or vulnerabilities</li>
            <li>Any loss of digital assets, cryptocurrency, or other value</li>
            <li>Any interruption, error, or unavailability of the service</li>
            <li>Any action or inaction taken based on information provided by CryptoGuardians</li>
          </ul>
          <p>
            <strong>
              CryptoGuardians is not responsible for any loss of cryptocurrency, tokens, digital
              assets, or funds.
            </strong>
          </p>

          <h2>10. Independent Decision-Making</h2>
          <p>
            <strong>
              Always conduct your own independent research before engaging in any cryptocurrency
              transaction.
            </strong>{' '}
            CryptoGuardians is designed to assist your decision-making process, not replace it.
            Consider consulting qualified professionals for financial, legal, and tax matters
            related to digital assets.
          </p>

          <h2>11. Agreement</h2>
          <p>
            By using CryptoGuardians, you confirm that you have read, understood, and agree to
            this Risk Disclaimer. If you do not agree with any part of this disclaimer, do not
            use the service.
          </p>

          <h2>12. Contact</h2>
          <p>
            Questions about this Risk Disclaimer? Contact us at{' '}
            <a href="mailto:legal@cryptoguardians.io">legal@cryptoguardians.io</a>.
          </p>

          <p className="legal-updated" style={{ marginTop: '3rem', borderTop: '1px solid var(--border-color)', paddingTop: '1.5rem' }}>
            CryptoGuardians is a product of HAJ Solutions Inc.
          </p>
        </div>
      </div>
    </div>
  );
}
